import { View } from '@mirai/ui';
import React from 'react';

export const Step2 = () => <View data-mirai-component="checkout" data-session="true" />;
